'use client';

import { Toaster } from 'sonner';
import { useIsMobile } from '@/hooks/useIsMobile';
import { ComponentProps } from 'react';

export function ToasterComponent() {
  const isTablet = useIsMobile(1090);
  const isMobile = useIsMobile(700);

  let position: ComponentProps<typeof Toaster>['position'] =
    'top-center' as const;
  if (isTablet) position = 'top-left' as const;
  if (isMobile) position = 'bottom-center' as const;

  return <Toaster position={position} />;
}
